import {
  TextField as BaseTextField,
  type TextFieldProps,
} from '@fv/client-components'

type Props = TextFieldProps
export const TextField = (props: Props) => {
  return <BaseTextField className="form-control" {...props} />
}
